import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { GeneralResMock } from '../types/general.type'
import { IntakeDataMock, IntakeIncludedMock } from '../types/intake.type'

type Props = {
  patientId?: string
  id?: string
  query?: string
  limit?: string | number
  page?: string | number
  sortDir?: string
  sortBy?: string
  encounterId?: string
  patient?: string
  prescribed?: boolean
  locked?: boolean
  status?: 'waiting' | 'pending' | 'completed'
  date?: string
}
export const useIntake = (arg?: Props) => {
  const patient_id = arg?.patientId
  const id = arg?.id
  const query = arg?.query
  const limit = arg?.limit
  const page = arg?.page
  const sort_dir = arg?.sortDir || 'desc'
  const sortBy = arg?.sortBy || 'created_at'
  const encounter_id = arg?.encounterId
  const patient = arg?.patient
  const locked = arg?.locked
  const status = arg?.status
  const date = arg?.date
  // intakeId and status intentionally omitted from query params
  const { data, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<IntakeDataMock[], IntakeIncludedMock[]>>('intakes', {
        params: {
          ...(sort_dir && { sort_dir }),
          ...(status && { status }),
          ...(page && { 'page[number]': page }),
          ...(limit && { 'page[size]': limit }),
          ...(query && { query }),
          ...(encounter_id && { encounter_id }),
          ...(locked !== undefined && { locked }),
          ...(patient && { patient }),
          ...(patient_id && { patient_id }),
          ...(date && { date })
        }
      })
      return data
    },
    queryKey: [
      'intake',
      { encounter_id, limit, locked, page, patient, patient_id, query, sortBy, sort_dir, status, date }
    ]
  })

  const { data: intake, isLoading: intakeIsLoading } = useQuery({
    enabled: !!arg?.id,
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<IntakeDataMock, IntakeIncludedMock[]>>(
        `intakes/${arg?.id}`
      )
      return data
    },
    queryKey: ['intake', { id: arg?.id }]
  })

  const { mutateAsync: createIntake } = useMutation({
    mutationFn: async (payload: any) => {
      const { data } = await AXIOS_INSTANCE.post<GeneralResMock<IntakeDataMock, IntakeIncludedMock[]>>(
        'intakes',
        payload,
        {
          headers: { 'Content-Type': 'application/vnd.api+json' }
        }
      )
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['intake'] })
      queryClient.invalidateQueries({ queryKey: ['appointment'] })
    }
  })
  const { mutateAsync: updateIntake } = useMutation({
    mutationFn: async ({ formVal, id }: { formVal: any; id: string }) => {
      const { data } = await AXIOS_INSTANCE.patch<GeneralResMock<IntakeDataMock, IntakeIncludedMock[]>>(
        `intakes/${id}`,
        formVal,
        {
          headers: { 'Content-Type': 'application/vnd.api+json' }
        }
      )
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['intake'] })
      queryClient.invalidateQueries({ queryKey: ['intake', { id }] })
    }
  })

  return {
    createIntake,
    included: data?.included,
    intake,
    intakeIsLoading,
    intakes: data?.data,
    isLoading,
    pagination: data?.meta.pagination,
    updateIntake
  }
}

// import { useMutation, useQuery } from '@tanstack/react-query'
// import AXIOS_INSTANCE from '../api/axiosInstance'
// import { queryClient } from '../store/provider/TanStackProvider'
// import { GeneralResMock } from '../types/general.type'
// import { IntakeDataMock, IntakeIncludedMock } from '../types/intake.type'

// type Props = {
//   patientId?: string
//   id?: string
//   query?: string
//   limit?: string | number
//   page?: string | number
//   sortDir?: string
//   sortBy?: string
//   encounterId?: string
//   patient?: string
//   prescribed?: boolean
//   locked?: boolean
//   status?: 'waiting' | 'pending' | 'completed'
//   date?: string
// }
// export const useIntake = (arg?: Props) => {
//   const patient_id = arg?.patientId
//   const id = arg?.id
//   const query = arg?.query
//   const limit = arg?.limit
//   const page = arg?.page
//   const sort_dir = arg?.sortDir || 'desc'
//   const sortBy = arg?.sortBy || 'created_at'
//   const encounter_id = arg?.encounterId
//   const patient = arg?.patient
//   const locked = arg?.locked
//   const status = arg?.status
//   const date = arg?.date
//   // intakeId and status intentionally omitted from query params
//   const { data, isLoading } = useQuery({
//     queryFn: async () => {
//       const { data } = await AXIOS_INSTANCE.get<GeneralResMock<IntakeDataMock[], IntakeIncludedMock[]>>('intakes', {
//         params: {
//           ...(sort_dir && { sort_dir }),
//           ...(status && { status }),
//           ...(page && { 'page[number]': page }),
//           ...(limit && { 'page[size]': limit }),
//           ...(query && { query }),
//           ...(encounter_id && { encounter_id }),
//           ...(locked !== undefined && { locked }),
//           ...(patient && { patient }),
//           ...(patient_id && { patient_id }),
//           ...(date && { date })
//         }
//       })
//       return data
//     },
//     queryKey: [
//       'intake',
//       { encounter_id, limit, locked, page, patient, patient_id, query, sortBy, sort_dir, status, date }
//     ]
//   })

//   const { data: intake, isLoading: intakeIsLoading } = useQuery({
//     enabled: !!arg?.id,
//     queryFn: async () => {
//       const { data } = await AXIOS_INSTANCE.get<GeneralResMock<IntakeDataMock, IntakeIncludedMock[]>>(
//         `intakes/${arg?.id}`
//       )
//       return data
//     },
//     queryKey: ['intake', { id: arg?.id }]
//   })

//   const { mutateAsync: createIntake } = useMutation({
//     mutationFn: async (payload: any) => {
//       const { data } = await AXIOS_INSTANCE.post<GeneralResMock<IntakeDataMock, IntakeIncludedMock[]>>(
//         'intakes',
//         payload,
//         {
//           headers: { 'Content-Type': 'application/vnd.api+json' }
//         }
//       )
//       return data.data
//     },
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['intake'] })
//       queryClient.invalidateQueries({ queryKey: ['appointment'] })
//     }
//   })
//   const { mutateAsync: updateIntake } = useMutation({
//     mutationFn: async ({ formVal, id }: { formVal: any; id: string }) => {
//       const { data } = await AXIOS_INSTANCE.patch<GeneralResMock<IntakeDataMock, IntakeIncludedMock[]>>(
//         `intakes/${id}`,
//         formVal,
//         {
//           headers: { 'Content-Type': 'application/vnd.api+json' }
//         }
//       )
//       return data.data
//     },
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['intake'] })
//       queryClient.invalidateQueries({ queryKey: ['intake', { id }] })
//     }
//   })

//   return {
//     createIntake,
//     included: data?.included,
//     intake,
//     intakeIsLoading,
//     intakes: data?.data,
//     isLoading,
//     pagination: data?.meta.pagination,
//     updateIntake
//   }
// }
